/**
 * nuxtが動的なsrcを解決できないため、それに対応するための関数
 * @param {string} imgPath - assets/images/ からはじまる画像のパス
 */
export const generateImgPath = (imgPath: string): string => {
  try {
    const assets = import.meta.glob("~/assets/images/**/*", {
      eager: true,
      import: "default",
    });
    // @ts-expect-error: wrong type info
    return assets["/" + imgPath];
  } catch (error) {
    // エラーログを仕込んでその後はthrowする
    sentryErrorLog(`generateImgPath: Failed to load image asset: ${imgPath}`, error);
    throw error;
  }
};

declare module "@vue/runtime-core" {
  interface ComponentCustomProperties {
    generateImgPath: (imgPath: string) => string;
  }
}
